export class PwaService {
  register(): void {
    const nativePlatform = (
      window as Window & { Capacitor?: { isNativePlatform?: () => boolean } }
    ).Capacitor?.isNativePlatform?.() ?? false;
    if (
      !("serviceWorker" in navigator)
      || !["http:", "https:"].includes(window.location.protocol)
      || nativePlatform
    ) return;

    window.addEventListener("load", () => {
      void navigator.serviceWorker.register("./sw.js", { scope: "./" });
    });
  }
}
